// API client for admin Assessment badges (/api/assessment/admin/badges).
//
// Envelope: { data, isError, statusCode, errorMessage }. The list is a page
// { content, page, size, totalElements, totalPages, hasNext } of rows
// { id, name, description, icon, criteriaType, thresholdPercentage, minCount,
//   isActive, createdAt, updatedAt, version, deletedAt, studentsEarned }.
// `icon` is an identifier the client renders (not a file). DELETE is soft: it
// deactivates the badge and stamps deletedAt. PUT is a partial update.
import api from "../axiosInstance";

const BASE = "/api/assessment/admin/badges";

export { apiErrorMessage } from "./assessmentHierarchy";

export const BADGE_CRITERIA_TYPES = [
  { value: "SCORE_THRESHOLD", label: "Score Threshold", needsThreshold: true, needsMinCount: false },
  { value: "ACCURACY_THRESHOLD_COUNT", label: "Accuracy Threshold Count", needsThreshold: true, needsMinCount: true },
  { value: "TIME_RATIO", label: "Time Ratio", needsThreshold: true, needsMinCount: false },
  { value: "STREAK_DAYS", label: "Streak (Days)", needsThreshold: false, needsMinCount: true },
  { value: "TOPIC_COMPLETION_COUNT", label: "Topic Completion Count", needsThreshold: false, needsMinCount: true },
  { value: "TOPIC_COMPLETION_ALL_IN_SUBJECT", label: "All Topics in a Subject", needsThreshold: false, needsMinCount: false },
];

export const criteriaTypeInfo = (value) => BADGE_CRITERIA_TYPES.find((c) => c.value === value);

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""),
  );

const unwrap = (res) => res.data?.data;

export const normalizeBadge = (b) => ({ ...b, status: b.isActive ? "ACTIVE" : "INACTIVE" });

// filters: isActive, criteriaType, page, size. Returns the page with normalised rows.
export const listBadges = async ({ page = 0, size = 20, ...filters } = {}) => {
  const res = await api.get(BASE, { params: cleanParams({ ...filters, page, size }) });
  const data = unwrap(res) || {};
  return { ...data, content: (data.content || []).map(normalizeBadge) };
};

// Payload: name, description, icon, criteriaType, thresholdPercentage, minCount, isActive.
export const createBadge = (payload) => api.post(BASE, payload).then(unwrap);
export const updateBadge = (id, payload) => api.put(`${BASE}/${id}`, payload).then(unwrap);
export const deleteBadge = (id) => api.delete(`${BASE}/${id}`).then(unwrap);
